import VenueAnnouncement from './VenueAnnouncement';

export default VenueAnnouncement;
